export const termEndPoints = {
  // quote
  boundaries: '/life/v2/product/boundaries',
  suggestion: '/life/v2/cover/suggestion',
  estimate: '/life/v2/premium/estimate',
  payoptions: '/life/v2/premium/payoptions',
  addons: '/life/v2/addons',
  features: '/life/v2/product/features',
  premium: '/life/v2/premium',
  verifyPincode: '/life/v2/verify-pincode',
  finalize: '/life/product',

  // ops - doc upload
  customerRequirements: '/ops/requirements',
  createInitialRequirements: '/ops/requirements/initial',
  docPresignedURL: '/ops/document/presigned-url',
  document: '/ops/document',
  requirementQuestionnaireDocument: '/ops/term/requirement_questionnaire_document',
  submitQuestionnaireDocument: (documentId: string) =>
    `/ops/term/requirement_questionnaire_document/${documentId}/send_otp`,
  submitQuestionnaireDocumentWhatsApp: (documentId: string) =>
    `/ops/term/requirement_questionnaire_document/${documentId}/send_whatsapp_otp`,
  confirmQuestionnaire: (documentId: string) =>
    `/ops/term/requirement_questionnaire_document/${documentId}/confirm`,
  // medicals
  questionnairePresignedUrl: (questionnaireId: string) =>
    `/ops/term/questionnaire/${questionnaireId}/presigned-url`,
  medicals: (policyId: string) => `/life/medicals/${policyId}`,
  labs: (policyId: string) => `/life/medicals/labs/${policyId}`,
  schedule: '/life/medicals/schedule',

  // proposal
  proposal: (policyId: string) => `/life/proposal/${policyId}`,
  submitProposal: (policyId: string) => `/life/proposal/${policyId}/submit`,
  hdfcLifePincodeData: (pincode: string) =>
    `/life/hdfc/pincode/data?pincode=${pincode}`,
  validateMLIPincode: (pincode: string) =>
    `/life/mli/validate-pincode?pincode=${pincode}`,

  // status
  status: (policyId: string) => `/life/v2/status/${policyId}`,

  // policy documents verification
  getPolicyDocuments: (policyId: string) => `/life/documents/${policyId}`,
  verifyPolicyDocuments: (policyId: string) => `/life/documents/${policyId}/verify`,

  // common
  countries: '/life/country_list',
  companies: '/life/companies'
};
